var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1776081178311,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2560,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.979592 1024h606.040816c115.461224 0 208.979592-93.518367 208.979592-208.979592V208.979592C1024 93.518367 930.481633 0 815.020408 0H208.979592C93.518367 0 0 93.518367 0 208.979592v606.040816c0 115.461224 93.518367 208.979592 208.979592 208.979592z",
    fill: "#16AEEE",
    "p-id": 2561
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.306122 668.734694h637.387756c26.017959 0 47.020408-21.002449 47.020408-47.020408S856.711837 574.693878 830.693878 574.693878h-637.387756c-26.017959 0-47.020408 21.002449-47.020408 47.020408s21.002449 47.020408 47.020408 47.020408z",
    fill: "#FFFFFF",
    "p-id": 2562
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M810.255673 759.902041l-318.693877-551.998694a46.957714 46.957714 0 0 0-64.229878-17.209469 46.957714 46.957714 0 0 0-17.209469 64.229877l318.693878 551.998694a46.957714 46.957714 0 0 0 64.229877 17.209469 46.957714 46.957714 0 0 0 17.209469-64.229877z",
    fill: "#FFFFFF",
    "p-id": 2563
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.693878 759.902041l318.693877-551.998694a46.957714 46.957714 0 0 1 64.229878-17.209469 46.957714 46.957714 0 0 1 17.209469 64.229877l-318.693878 551.998694a46.957714 46.957714 0 0 1-64.229877 17.209469 46.957714 46.957714 0 0 1-17.209469-64.229877z",
    fill: "#FFFFFF",
    "p-id": 2564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/appStore.fdbac6c33496d0334cb55e8eb1540f54.svg";
export { ForwardRef as ReactComponent };